export default __webpack_public_path__ + "static/poster-f3a1e19db1a791960dac4439a67b9526.jpg";